import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthserviceService } from '../@core/services/authservice.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  standalone: false
})
export class ChangePasswordComponent {
  currentPassword = '';
  newPassword = '';
  confirmation = '';
  saving = false;
  errorMessage = '';

  constructor(private auth: AuthserviceService, private router: Router) {}

  submit(): void {
    this.errorMessage = '';
    if (this.newPassword.length < 8) {
      this.errorMessage = 'La nueva contraseña debe tener al menos 8 caracteres.';
      return;
    }
    if (this.newPassword !== this.confirmation) {
      this.errorMessage = 'Las nuevas contraseñas no coinciden.';
      return;
    }
    this.saving = true;
    this.auth.changeOwnPassword(this.currentPassword, this.newPassword)
      .pipe(finalize(() => this.saving = false))
      .subscribe({
        next: () => {
          this.auth.clearSession();
          this.router.navigate(['/login-portal']);
        },
        error: err => {
          this.errorMessage = typeof err?.error?.detail === 'string'
            ? err.error.detail : 'No se ha podido actualizar la contraseña.';
        }
      });
  }

  cancel(): void {
    this.auth.clearSession();
    this.router.navigate(['/login-portal']);
  }
}
